import moment from 'moment';

export function allowAllValuesExceptSpace(event) {
    let char = event.target.value.replace(/\s/g, "");
    event.target.value = char;
}

export function allowOnlyPositiveIntegerValue(event, isValue = false) {
    let value = isValue ? ((isNaN(event) || event !== "") ? event.toString() : event) : event.target.value;
    let number = value.replace(/[^0-9]/g, "");
    if (isValue)
        return event = number;
    else
        return event.target.value = number;
}

export function emailValidation(email) {
    // if (!email) return false;
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var isValidMail = re.test(email);
    return isValidMail;
}

export function formatAttestationDate(date) {
    return `${moment(date).format('ddd')} ${moment(date).format('MM/DD/YYYY')}`
}

export function isTwoObjectSame(obj1, obj2) {
    if ((!obj1 && obj2) || (obj1 && !obj2)) return false;
    if (Array.isArray(obj1) || Array.isArray(obj2)) return false;
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;

    for (const key in obj1) {
        if (obj1[key] !== obj2[key]) {
            return false;
        }
    }

    return true;
}